import { createContext, useContext } from 'react';
import type { CivilDate } from '@hue/design-system';

export type OperationalMonth = `${number}-${string}` | 'ALL';

export interface OperationalPeriod {
  month: OperationalMonth;
  setMonth: (month: OperationalMonth) => void;
  from?: CivilDate;
  to?: CivilDate;
}

export const OperationalPeriodContext = createContext<OperationalPeriod | null>(null);

export function useOperationalPeriod(fallbackToday?: CivilDate): OperationalPeriod {
  const period = useContext(OperationalPeriodContext);
  if (period) return period;
  if (!fallbackToday) throw new Error('Mês operacional não disponível.');
  const month = fallbackToday.slice(0, 7) as OperationalMonth;
  return { month, setMonth: () => undefined, ...monthBounds(month) };
}

export function monthBounds(month: OperationalMonth): { from?: CivilDate; to?: CivilDate } {
  if (month === 'ALL') return {};
  const [year, number] = month.split('-').map(Number) as [number, number];
  const last = new Date(Date.UTC(year, number, 0)).getUTCDate();
  return {
    from: `${month}-01`,
    to: `${month}-${String(last).padStart(2, '0')}`,
  };
}
